<template>
    <YearPickerPrev
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-left"
        size="xs"
        tooltipText="Previous years"
    />
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { YearPickerPrevProps } from 'reka-ui';
import { YearPickerPrev, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<YearPickerPrevProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
